import {useWatch} from 'react-hook-form';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {SeatCountChips} from './SeatCountChips';
import {SeatCountNumberField} from './SeatCountNumberField';

export function SeatCountField() {
  const {control} = useVehicleFormContext();
  const type = useWatch({control, name: 'type'});

  return type?.at(0) === 'VEHICLETYPE_BUS' ? <SeatCountNumberField /> : <SeatCountChips />;
}
